import { useParams } from "react-router";
import { ContractForOffer } from "@/routes/processes/[processId]/rlt/offers/[offerId]/contract/_components/contract-for-offer";

export function OfferContractRoute() {
  const { offerId } = useParams();

  return <ContractForOffer offerId={offerId!} />;
}
